// MessagePackModals.jsx
import React from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';

import UniversalComponent from '../component/UniversalComponent.jsx';

import { SHOP_ID } from '../resource/shopConstants.js';

export const MessagePackModals = ({ shopId = SHOP_ID.messagePack }) => {
  return (
    <>
      <ModalView id={`${shopId}.ConfirmOrderEmailInput`}>
        <UniversalComponent
          filename="Container_ConfirmOrderEmailInput"
          shopId={shopId}
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/ConfirmOrderEmailInput.js')
          }
        />
      </ModalView>
    </>
  );
};

MessagePackModals.propTypes = {
  shopId: PropTypes.string,
};

export default MessagePackModals;
